import WP from './wp'

export default WP
